import $api from '@/api'

// 获取所有SSR信息
export const getAllSsr = (): any => {
  return $api.get('/ssr')
}

// 获取所有SSR更新信息
export const getUpdateSsr = (pageNumber: number): any => {
  return $api.get('/updates', { pageNumber })
}
